<div *ngIf="showComponent1">
    <app-first-page></app-first-page>
  </div>
  <div *ngIf="showComponent2">
    <app-create-edit-page></app-create-edit-page>
  </div>